module.exports = __webpack_public_path__ + "static/babibooks-be718856b659c80bdf9aad6237315c8e.jpg";